import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';

export const formSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: getTranslation('REQUIRED') })
    .max(40, { message: getTranslation('MAXIMUM_CHARACTERS', { count: 40 }) }),
});

export type FormSchema = z.infer<typeof formSchema>;
